

export default function(state = {}, action){

  if (action.type == 'ADD_REPOSITORY'){
    var repository = action.payload.repository
    state = Object.assign({}, state)
    state[repository.id] = Object.assign({}, state[repository.id], repository)
  }

  if (action.type == 'ADD_BRANCH'){
    const { branch } = action.payload
    state = Object.assign({}, state)
    state[branch.repositoryId] = Object.assign({}, state[branch.repositoryId])
    state[branch.repositoryId].branches = Object.assign([], state[branch.repositoryId].branches)
    if (state[branch.repositoryId].branches.includes(branch.id) == false)
      state[branch.repositoryId].branches.push(branch.id)
  }

  if (action.type == 'SET_SELECTED_BRANCH'){
    const { branchId, repositoryId } = action.payload
    state = Object.assign({}, state)
    state[repositoryId] = Object.assign({}, state[repositoryId])
    state[repositoryId].selectedBranch = branchId
  }

  return state
}


// WEBPACK FOOTER //
// ./src/store/repositories/reducer.js